import { GridMenu, GridMenuItem, GridMenuItemType, MenuButton } from '../../WdpInterfaces';

const flattenMenuItem = (item: GridMenuItem): MenuButton[] =>
    item.type === GridMenuItemType.Menu ? item.menu.items.flatMap(flattenMenuItem) : [item.button];

export const flattenMenu = (menu: GridMenu): MenuButton[] => flattenMenuItem({ type: GridMenuItemType.Menu, menu });
